
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulic11Static as ObiHydraulic11StaticElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-11-static.js';
 
 
 

 
 export const ObiHydraulic11Static = createComponent({
   react: React,
   tagName: 'obi-hydraulic-11-static',
   elementClass: ObiHydraulic11StaticElement,
   events: {
     
   }
  });
 
 